import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eefcd0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-filters" }
const _hoisted_2 = { class: "map-filters__header" }
const _hoisted_3 = { class: "map-filters__title" }
const _hoisted_4 = { class: "map-filters__title-count" }
const _hoisted_5 = { class: "map-filters__types" }
const _hoisted_6 = {
  key: 0,
  class: "map-filters__hidden filters-list"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "filters-list__title" }, "Физические данные", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "filters-list__title" }, "Расценки", -1 /* HOISTED */))
const _hoisted_9 = { class: "switches" }
const _hoisted_10 = {
  key: 1,
  class: "map-filters__action"
}

import { computed, ComputedRef, onMounted, ref, Ref } from "vue";
import ArrowIcon from "@/common/icons/ArrowIcon.vue";
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import { profileTypes } from "@/common/types/profileTypes";
import DigitalBlock from "@/searchSection/components/SearchPanel/DigitalBlock.vue";
import pSwitch from "@/common/pSwitch/pSwitch.vue";
import pButton from "@/common/pButton/pButton.vue";
import { IMapFilters } from "@/mapSearch/types/MapFilters";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapFilters',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
},
  emits: ['toggleFilters', 'showProfiles'],
  setup(__props, { emit: __emit }) {



const emits = __emit;

const descriptionTypes: object = {
  1: 'Индивидуалки',
  2: 'Массажистки',
  3: 'БДСМ',
}

const profileTypesList: ComputedRef<profileTypes[]> = computed(() => {
  return Object.keys(profileTypes)
      .filter((type) => !isNaN(Number(type)))
      .map((type) => Number(type))
})

const filters: Ref<IMapFilters> = ref({
  profileTypes: [1, 2, 3] as number[],
  age: {
    from: '' as string,
    to: '' as string
  },
  chestSize: {
    from: '' as string,
    to: '' as string
  },
  height: {
    from: '' as string,
    to: '' as string
  },
  weight: {
    from: '' as string,
    to: '' as string
  },
  priceInfo: {
    oneHour: {
      from: '' as string,
      to: '' as string
    },
    twoHour: {
      from: '' as string,
      to: '' as string
    },
    isNight: false,
    type: 'home' as 'home' | 'visit',
  },
});

const twoHourLabel = computed(() => {
  return filters.value.priceInfo.isNight ? 'Ночь' : '2 часа'
})

function togglePriceType() {
  filters.value.priceInfo.type = filters.value.priceInfo.type === 'home' ? 'visit' : 'home'
}

onMounted(() => {
  emits('showProfiles', filters.value)
})

const toggleType = (type: number) => {  
  const index = filters.value.profileTypes.indexOf(type);
  if (index === -1) {
    filters.value.profileTypes.push(type);
  } else {
    filters.value.profileTypes.splice(index, 1);
  }
  emits('showProfiles', filters.value)
}

const filtersCount = computed(() => {
  let count = 0;
  
  count += filters.value.profileTypes.length;

  Object.keys(filters.value).forEach((key) => {
    if (filters.value[key].from || filters.value[key].to) {
      if (filters.value[key].from !== '') count++;
      if (filters.value[key].to !== '') count++;
    }
  })

  if (filters.value.priceInfo.type === 'visit') {
    count += 1;
  }

  if (filters.value.priceInfo.isNight) {
    count += 1;
  }
  
  return count;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" Фильтр"),
        _createElementVNode("span", _hoisted_4, "Указаны - " + _toDisplayString(filtersCount.value) + " параметр", 1 /* TEXT */)
      ]),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["map-filters__arrow", { 'map-popup__arrow_active': __props.visible }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilters')))
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileTypesList.value, (type) => {
        return (_openBlock(), _createBlock(pCheckbox, {
          key: type,
          class: _normalizeClass(_unref(profileTypes)[type].toLowerCase()),
          modelValue: filters.value.profileTypes.includes(type),
          "onUpdate:modelValue": ($event: any) => (toggleType(type)),
          label: descriptionTypes[type],
          onInput: ($event: any) => (toggleType(type))
        }, null, 8 /* PROPS */, ["class", "modelValue", "onUpdate:modelValue", "label", "onInput"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(DigitalBlock, {
            first: filters.value.age.from,
            "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.age.from) = $event)),
            second: filters.value.age.to,
            "onUpdate:second": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.age.to) = $event)),
            title: "Возраст",
            orText: "-",
            firstPlaceholder: 'от 18 лет',
            secondPlaceholder: 'до 35 лет',
            onFirstInput: _cache[3] || (_cache[3] = (v) => filters.value.age.from = v),
            onSecondInput: _cache[4] || (_cache[4] = (v) => filters.value.age.to = v)
          }, null, 8 /* PROPS */, ["first", "second"]),
          _createVNode(DigitalBlock, {
            first: filters.value.chestSize.from,
            "onUpdate:first": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.chestSize.from) = $event)),
            second: filters.value.chestSize.to,
            "onUpdate:second": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.chestSize.to) = $event)),
            title: "Размер груди",
            orText: "-",
            firstPlaceholder: 'от 1',
            secondPlaceholder: 'до 12',
            onFirstInput: _cache[7] || (_cache[7] = (v) => filters.value.chestSize.from = v),
            onSecondInput: _cache[8] || (_cache[8] = (v) => filters.value.chestSize.to = v)
          }, null, 8 /* PROPS */, ["first", "second"]),
          _createVNode(DigitalBlock, {
            first: filters.value.height.from,
            "onUpdate:first": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.height.from) = $event)),
            second: filters.value.height.to,
            "onUpdate:second": _cache[10] || (_cache[10] = ($event: any) => ((filters.value.height.to) = $event)),
            title: "Рост",
            orText: "-",
            firstPlaceholder: 'от 130 см',
            secondPlaceholder: 'до 210 см',
            onFirstInput: _cache[11] || (_cache[11] = (v) => filters.value.height.from = v),
            onSecondInput: _cache[12] || (_cache[12] = (v) => filters.value.height.to = v)
          }, null, 8 /* PROPS */, ["first", "second"]),
          _createVNode(DigitalBlock, {
            first: filters.value.weight.from,
            "onUpdate:first": _cache[13] || (_cache[13] = ($event: any) => ((filters.value.weight.from) = $event)),
            second: filters.value.weight.to,
            "onUpdate:second": _cache[14] || (_cache[14] = ($event: any) => ((filters.value.weight.to) = $event)),
            title: "Вес",
            orText: "-",
            firstPlaceholder: 'от 30 кг',
            secondPlaceholder: 'до 100 кг',
            onFirstInput: _cache[15] || (_cache[15] = (v) => filters.value.weight.from = v),
            onSecondInput: _cache[16] || (_cache[16] = (v) => filters.value.weight.to = v)
          }, null, 8 /* PROPS */, ["first", "second"]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(pSwitch, {
              firstLabel: 'Апартаменты',
              secondLabel: 'Выезд',
              modelValue: filters.value.priceInfo.type === 'visit',
              "onUpdate:modelValue": togglePriceType
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(pSwitch, {
              modelValue: filters.value.priceInfo.isNight,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((filters.value.priceInfo.isNight) = $event)),
              firstLabel: 'День',
              secondLabel: 'Ночь'
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createVNode(DigitalBlock, {
            first: filters.value.priceInfo.oneHour.from,
            "onUpdate:first": _cache[18] || (_cache[18] = ($event: any) => ((filters.value.priceInfo.oneHour.from) = $event)),
            second: filters.value.priceInfo.oneHour.to,
            "onUpdate:second": _cache[19] || (_cache[19] = ($event: any) => ((filters.value.priceInfo.oneHour.to) = $event)),
            title: "1 час",
            orText: "-",
            firstPlaceholder: "От ₽",
            secondPlaceholder: "До ₽",
            onFirstInput: _cache[20] || (_cache[20] = (v) => filters.value.priceInfo.oneHour.from = v),
            onSecondInput: _cache[21] || (_cache[21] = (v) => filters.value.priceInfo.oneHour.to = v)
          }, null, 8 /* PROPS */, ["first", "second"]),
          _createVNode(DigitalBlock, {
            first: filters.value.priceInfo.twoHour.from,
            "onUpdate:first": _cache[22] || (_cache[22] = ($event: any) => ((filters.value.priceInfo.twoHour.from) = $event)),
            second: filters.value.priceInfo.twoHour.to,
            "onUpdate:second": _cache[23] || (_cache[23] = ($event: any) => ((filters.value.priceInfo.twoHour.to) = $event)),
            title: twoHourLabel.value,
            orText: "-",
            firstPlaceholder: "От ₽",
            secondPlaceholder: "До ₽",
            onFirstInput: _cache[24] || (_cache[24] = (v) => filters.value.priceInfo.twoHour.from = v),
            onSecondInput: _cache[25] || (_cache[25] = (v) => filters.value.priceInfo.twoHour.to = v)
          }, null, 8 /* PROPS */, ["first", "second", "title"])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(pButton, {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (emits('showProfiles', filters.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Показать")
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})